import createReactComponent from '../createReactComponent';
export default createReactComponent('underline', 'IconUnderline', [
  ['path', { d: 'M7 5v5a5 5 0 0 0 10 0v-5', key: 'svg-0' }],
  ['path', { d: 'M5 19h14', key: 'svg-1' }],
]);
